export const GET_SCHOOL_INFO = "GET_PROGRAM_INFO";
export const GET_SCHOOL_INFO_SUCCESS = "GET_PROGRAM_INFO_SUCCESS";
export const GET_SCHOOL_INFO_ERROR = "GET_PROGRAM_INFO_ERROR";
export const REGISTER_FOR_PROGRAM = "REGISTER_FOR_PROGRAM";
export const REGISTER_FOR_PROGRAM_SUCCESS = "REGISTER_FOR_PROGRAM_SUCCESS";
export const REGISTER_FOR_PROGRAM_ERROR = "REGISTER_FOR_PROGRAM_ERROR";
